import { AlertTriangle } from 'lucide-react'
import * as React from 'react'
import { Link } from 'react-router'
import { Button } from './ui/button'
import { Card, CardContent } from './ui/card'
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from './ui/collapsible'
import { Icon } from './ui/icon'

export function ErrorPage(props: { msg: string | React.ReactNode }) {
	const [isOpen, setIsOpen] = React.useState(false)

	const handleReload = () => {
		window.location.reload()
	}

	return (
		<div className="flex min-h-screen items-center justify-center bg-background p-4">
			<div className="mx-auto w-full max-w-md">
				<Card className="border-border shadow-lg">
					<CardContent className="space-y-6 p-8 text-center">
						<div className="flex justify-center">
							<div className="relative">
								<div className="flex h-20 w-20 items-center justify-center rounded-full bg-primary/10">
									<Icon name="scale" className="h-10 w-10 text-primary" />
								</div>
								<div className="absolute -right-1 -top-1 flex h-8 w-8 items-center justify-center rounded-full bg-destructive/10">
									<AlertTriangle className="h-4 w-4 text-destructive" />
								</div>
							</div>
						</div>

						<div className="space-y-3">
							<h1 className="text-2xl font-bold text-foreground">Error Inesperado</h1>
							<p className="leading-relaxed text-muted-foreground">
								Ha ocurrido un error inesperado en el sistema. Por favor, verifique su conexión a Internet o intente
								nuevamente en unos momentos.
							</p>
						</div>

						<div className="space-y-3 pt-2">
							<Button onClick={handleReload} className="w-full" size="lg">
								<Icon name="refresh" className="h-4 w-4">
									Recargar Página
								</Icon>
							</Button>

							<Button variant="outline" className="w-full border-border bg-transparent hover:bg-muted" size="lg">
								<Link to="/ai">Volver al Inicio</Link>
							</Button>
						</div>
						<Collapsible open={isOpen} onOpenChange={setIsOpen} className="pt-2">
							<CollapsibleTrigger asChild>
								<Button
									variant="ghost"
									size="sm"
									className="h-auto w-full p-2 text-xs text-muted-foreground hover:text-foreground"
								>
									<span>Mensaje técnico detallado</span>
									<Icon
										name="chevron-down"
										className={`ml-2 h-3 w-3 transition-transform ${isOpen ? 'rotate-180' : ''}`}
									/>
								</Button>
							</CollapsibleTrigger>
							<CollapsibleContent className="pt-2">
								<div className="rounded-md bg-muted/50 p-3 text-left">
									<p className="font-mono text-xs leading-relaxed text-muted-foreground">{props.msg}</p>
								</div>
							</CollapsibleContent>
						</Collapsible>

						<div className="border-t border-border pt-4">
							<p className="text-sm text-muted-foreground">
								Si el problema persiste, contacte a nuestro{' '}
								<Link
									to="mailto:soporte@iuspro.com"
									className="font-medium text-primary underline hover:text-primary/80"
								>
									equipo de soporte técnico
								</Link>
							</p>
						</div>
					</CardContent>
				</Card>

				<div className="mt-6 text-center">
					<p className="text-xs text-muted-foreground">Asistente Legal IA • Costa Rica</p>
				</div>
			</div>
		</div>
	)
}
